import { ReactElement, useState } from "react";
import { ReactComponent as ChatBubbleIcon } from '../../assets/icons-redesign/chat-bubble.svg';
import { useViewSurveyChildren, ViewSurveyChildrenProps } from "./useViewSurveyChildren";
// import { useSurveyMediaPlan } from "../view-survey/survey-action-plan/useSurveyMediaPlan";
import { ReactComponent as Loading } from "../../assets/icons/loading.svg";
// import { ReactComponent as Star } from "../../assets/icons-redesign/ai-star.svg";
import { useSurveySummary } from "../view-survey/survey-action-plan/useSurveySummary";


export enum SurveySummaryTab {
  Summary, MediaPlan
}

export interface SurveySummaryHeaderProps extends ViewSurveyChildrenProps {
  readonly initialTab: SurveySummaryTab;
  readonly onTabChange: (tab: SurveySummaryTab) => void;
}

const SurveySummaryHeader = ({ initialTab, onTabChange, surveyId, isShare }: SurveySummaryHeaderProps): ReactElement => {
  const [activeTab, setActiveTab] = useState<SurveySummaryTab>(initialTab);
  const { survey } = useViewSurveyChildren(surveyId, isShare);
  // const { isLoadingPlan, isGeneratingMediaPlan } = useSurveyMediaPlan(surveyId, survey?.surveyStatus, isShare);
  const { isLoadingSummary, isGeneratingSummary } = useSurveySummary(surveyId, survey?.surveyStatus, isShare);

  const onTabClick = (tab: SurveySummaryTab) => {
    setActiveTab(tab);
    onTabChange(tab);
  };

  const renderHeaderTab = (tab: SurveySummaryTab, label: string, icon?: ReactElement, canClick: boolean = true) => {
    const isActive = activeTab === tab;
    return (
      <div className={`flex py-4 px-1`} >
        <div
          className={`cursor-pointer flex items-center gap-1.5 text-sm md:text-base font-medium ${isActive ? 'text-white' : 'text-blue-300'}`}
          onClick={() => canClick && onTabClick(tab)}
        >
          {icon}
          {label}
        </div>
      </div>
    );
  };

  const iconStroke = activeTab === SurveySummaryTab.Summary ? 'white' : '#8FA3FF';
  return (
    <div className={`flex w-full gap-2 top-0 z-40 bg-blue-500 h-14 px-6 rounded-t-lg`}>
      {renderHeaderTab(SurveySummaryTab.Summary, 'Survey Summary', isGeneratingSummary || isLoadingSummary ? <Loading className="animate-spin stroke-white" /> : <ChatBubbleIcon stroke={iconStroke} />)}
      {/* {renderHeaderTab(SurveySummaryTab.MediaPlan, 'Media Plan', isGeneratingMediaPlan || isLoadingPlan ? <Loading className="animate-spin stroke-white" /> : <Star stroke={iconStroke} />)} */}
    </div>
  );
};

export default SurveySummaryHeader;
